if (!customElements.get('delivery-notice')) {
  customElements.define(
    'delivery-notice',
    class DeliveryNotice extends window.BAO.CustomElement() {
      connectedCallback () {
        super.connectedCallback()

        const activeShop = window.Shopify.shop

        if (activeShop !== 'oh-polly-uk.myshopify.com') return

        window.BAO.geoLocationPromise.finally(() => {
          this.checkVisibility()
        })
      }

      checkVisibility () {
        const customerCountryCode = window.theme.customer.countryCode

        if (customerCountryCode !== 'GB') {
          this.setAttribute('hidden', '')
        }
      }
    },
  )
}
